const config = {
  initiateLoginEndpoint: process.env.REACT_APP_START_LOGIN_PAGE_URL?.endsWith(
    "/"
  )
    ? process.env.REACT_APP_START_LOGIN_PAGE_URL.slice(0, -1)
    : process.env.REACT_APP_START_LOGIN_PAGE_URL,
  clientId: process.env.REACT_APP_CLIENT_ID,
  appId: process.env.REACT_APP_TEAMS_APP_ID || "",
  tcAppId: process.env.REACT_APP_TC_APP_ID,
  teamsFxEnv: process.env.REACT_APP_TEAMSFX_ENV,
  version: process.env.REACT_APP_TEAMCENTER_TEAMS_VERSION,
  appInsightsConnectionString:
    process.env.REACT_APP_INSIGHTS_CONNECTION_STRING !== "none"
      ? process.env.REACT_APP_INSIGHTS_CONNECTION_STRING
      : "",
  logConsole: process.env.REACT_APP_LOG_CONSOLE,
  logLevel: process.env.REACT_APP_LOG_LEVEL,
  environment: process.env.REACT_APP_ENV
    ? process.env.REACT_APP_ENV
    : process.env.NODE_ENV
      ? process.env.NODE_ENV
      : "production",
  tcTeamsWebApiUrl: process.env.REACT_APP_TEAMS_API_URL?.endsWith("/")
    ? process.env.REACT_APP_TEAMS_API_URL.slice(0, -1)
    : process.env.REACT_APP_TEAMS_API_URL,
  teamsAppIds: Object.keys(process.env)
    .filter((key) => key.includes("TEAMS_APP_ID"))
    .reduce(
      (acc, key) => {
        // It's safe to use non-null assertion since the key is present.
        acc[key] = process.env[key]!;
        return acc;
      },
      {} as Record<string, string>
    ),
};

export default config;
